import {
  Box,
  Button,
  Flex,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { RiAddFill } from "react-icons/ri";
import { useDispatch } from "react-redux";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import {
  openCreateSubjectAssistPhone,
} from "../../../modules/admin-modules/models/Actions";

const SearchBar = ({ setAdd, setSelectedData, subjectAssistPhones }) => {
  const dispatch = useDispatch();
  
  return (
    <VStack w="100%" my={{ base: "50px", md: "30px" }}>
      <Flex
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          width={{ base: "100%", md: "20%" }}
          mb={{ base: "10px", md: 0 }}
        >
          أرقام الاسيستانت
        </Text>

        <Flex alignItems="center" gap={2}>
          <Button
            borderRadius="16px"
            leftIcon={<RiAddFill />}
            mx="8px"
            color="white"
            bg="main_1"
            _focus={{ outline: "none" }}
            onClick={() => {
              setAdd(true);
              dispatch(openCreateSubjectAssistPhone());
            }}
          >
            إضافة رقم
          </Button>

          <Box display={{ base: "none", md: "block" }}>
            <LogoutMenu />
          </Box>
        </Flex>
      </Flex>
      <Text w="100%" fontSize="20px" textAlign="right">
        {" "}
        عدد الأرقام: {subjectAssistPhones?.length || 0}
      </Text>
    </VStack>
  );
};

export default SearchBar;

